import { BoxProps, ColorOptions } from '@jfs/ui-new'

export const style = (respPadding: number, isMobile: boolean) => ({
  mainViewWrap: {
    justify: 'center',
  } as BoxProps,
  container: {
    pt: isMobile ? 50 : 100,
    bg: 'WHITE',
    ph: respPadding,
  } as BoxProps,
  footerBackground: {
    pt: 110,
    boxShadow: '0px 4px 4px #00000029' as ColorOptions,
    bg: 'WHITE',
    pb: 110,
  } as BoxProps,
})
